export default __webpack_public_path__ + "static/ImageTeaserJourney-100width-807c87316753ff955cabc346abc81531.png";